<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <br />

    <tl-header type="h1">
      <div class="main-header margintop-10">FBP Reimbursement Claim Details</div>
    </tl-header>
  
    <div class="margintop-10">
      <p>Employee Code :  {{employeeDocs[0].Employee.code}}</p>
        <p>Employee Name :  {{employeeDocs[0].Employee.first_name+" "+employeeDocs[0].Employee.last_name}}</p>
        <p >
          Date :  {{formatDate(employeeDocs[0].created_at)}}
          </p>
          <div v-for="(item, i) of employeeDocs[0].details" :key="i">
            <p>FBP Component :  {{item}}</p>
          </div>
        <p>Claim Amount :  {{employeeDocs[0].amount_claimed}}</p>
        </div>
        <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
      />
      <pop-up-message
      v-if="showSuccessMsg"
      :message="`FBP Claim has been successfully Approved`"
      btnText="Back"
      @back="backfrompopup()"
    />
        <div :disabled="!(ifAdmin || ifHr)">
        <div v-if="showError">
          <p  style="color: #842029;">*Approved Amount should be less than Claim Amount</p>
        </div>
          <data-table
            class="custom-data"
            :columns="employeeTableColumns"
            :tableData="employeeDocs"
            :showinrow="false"
            :showedit="false"
            :showhistory="false"
            :showdelete="false"
          >
            <template v-slot:rowcontent="slotprops">
              <div>
                <div
              v-if="slotprops.value.column.key=='particulars'"
            ><p v-for="(item, i) of slotprops.value.record.details" :key="i">{{item}}</p></div>
            <div
              v-if="slotprops.value.column.key=='bill_date'"
            >{{formatDate(slotprops.value.record.bill_date)}} </div>
            <txt class="custom" v-if="slotprops.value.column.key == 'amount_approved'"
            :autofocus="false"
            name="approveAmount"
            type="text"
            v-model="slotprops.value.record[slotprops.value.column.key]"
            @change="(val)=>saveValues(val,slotprops.value.record,'amount_approved')"
            />
            <div class="text-capitals"
              v-if="slotprops.value.column.key=='amount_claimed'"
            >{{formateLess.format(slotprops.value.record.amount_claimed)}} </div>
            <div class="text-capitals" :key="componentKey"
              v-if="slotprops.value.column.key=='rejectedAmount'"
            >{{formateLess.format(slotprops.value.record.amount_claimed-slotprops.value.record.amount_approved)}} </div>
             <txt class="custom" v-if="slotprops.value.column.key == 'remark'"
            :autofocus="false"
            name="remark"
            type="text"
            v-model="slotprops.value.record[slotprops.value.column.key]"
            @change="(val)=>saveRemark(val,slotprops.value.record,'remark')"
            />
                <div v-if="slotprops.value.column.key == 'imgSrc'">
                  <img
                    class="document-img"
                    v-if="slotprops.value.column.key == 'imgSrc'"
                    :src="require('@/assets/invalid-name.svg')"
                    @click="openModal(slotprops.value)"
                    alt
                  />
                  <span class="document-counts">
                    {{ slotprops.value.record["bill"] ? 1 : 0 }}
                  </span>
                </div>

                <p
                v-if="slotprops.value.column.key!='particulars' && slotprops.value.column.key!='rejectedAmount' && 
                slotprops.value.column.key!='imgSrc' && slotprops.value.column.key!='bill_date' &&
                slotprops.value.column.key!='amount_claimed' &&
                slotprops.value.column.key!='amount_approved'&& slotprops.value.column.key!='remark'"
                >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              </div>
            </template>
      </data-table>

      <pop-up-window
        v-if="showFullDocuments"
        @back="showFullDocuments = !showFullDocuments"
        header="Attachments">
          <template v-slot:content>
            <img :src="showImage" alt="">
            <full-document-show
            :document="fullDocument"
                        @back="showFullDocuments = !showFullDocuments">
            </full-document-show>
         </template>

      </pop-up-window>

      </div>
      <bottom-action-container class="placeEnd">
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="back" />
          <btn
            :disabled="!(ifAdmin || ifHr) || showError"
            text="Approve FBP Claim"
            type="primary"
            @click="approveFbpClaim"
          />
        </btn-grp>
      </template>
    </bottom-action-container>
        </div>
        </template>
          

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { createDecipheriv } from 'crypto';

import FullDocumentShow from "./showDocument.vue";
import {S3} from "aws-sdk";
export default {
  name: "EditFbpClaims",
  components: {
    FullDocumentShow,
  },
  data() {
    return {
      formate: "",
      formateLess:"",
      changeListRequest: "",
      monthSelected: "",
      listRequestLabel: "",
      file_name_with_extenstion:"",
      employeeData: [],
      employeeDocs:[],
      componentList:[],
      showError:false,
      toast:false,
            componentKey:0,
      updatedRemark:'',
      errmsg:"",
      showFullDocuments:false,
      showImage:null,
      showSuccessMsg: false,
      fullDocument: null,
      preSignedUrl:"",
      count:0,
      employeeTableColumns: [
        {
          label: "Particulars",
          key: "particulars",
        },
        {
          label: "Bill No.",
          key: "bill_number",
        },
        {
          label: "Bill Date",
          key: "bill_date",
        },
        {
          label: "Amount",
          key: "amount_claimed",
          style:"text-align:right"
        },
        {
          label: "Approved Amount",
          key: "amount_approved",
        },
        {
          label: "Rejected Amount",
          key: "rejectedAmount",
          style:"text-align:right"
        },
        {
          label: "Attachments",
          key: "imgSrc",
        },
        {
          label: "Remarks",
          key: "remark",
        },
      ],
      formData: {
        
      },
      employeeDetails: {},
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`,
        },
        {
          name: "FBP",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll`,
        },
        {
          name: "Approve/View Approved Claims",
          url: "",
        },
      ],
    };
  },

  computed: {
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      record: "dashboard/payroll/utilities/approveFbpClaims/record",
      editMode: "dashboard/payroll/utilities/approveFbpClaims/editMode"
    }),
    
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      }
      return this.getLegalEntityId(0);
    },

    ...mapState("onboard/organization", {
      orgIds: (state) => state.id,
    }),
    

    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if(this.companyValue) {
          return true;
        } else {
          return false;
        }
      } 
    },

    ifAdmin() {
      return localStorage.getItem("userRole") == "ADMIN" ? true : false;
    },
    ifHr() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
  },

  mounted() {
    this.getOrgLeIdList();
    this.componentList=[];
  },
  activated() {
    this.getOrgLeIdList();
    this.componentList=[];
    this.employeeDocs = [];
    if (this.editMode) {
      this.formData = this.record;
      this.employeeDocs.push(this.formData);
  }
  },

  methods: {
    ...mapActions({
      act_update: "dashboard/payroll/utilities/approveFbpClaims/update",
    }),
    ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),
    ...mapActions({
    getPreSignedUrl: "payroll/lopsandrlops/createPreSigned",
    }),


   async openModal(category) {
      this.showFullDocuments = false;
      this.preSignedUrl = this.formData['bill']
       this.fullDocument = await this.downloadUrl()
    },



    async preSignedUrlFunction() {
  try {
    let res = await this.getPreSignedUrl({
      url: this.formData['bill']
    });
    if (res.data.payload && res.data.payload.iv && res.data.payload.encryptedPacket) {
      const decryptedLink = await this.decrypt(res.data.payload);
      return decryptedLink;
    } else {
      console.log('Invalid payload structure');
      return null;
    } 
  } catch (e) {
    console.log('Error in preSignedUrlFunction:', e);
    return null; 
  }
},

    async downloadUrl() {
      try {
        const downloadLink = await this.preSignedUrlFunction();
        if (downloadLink) {
          console.log("link...............",downloadLink )
          let url = JSON.parse(downloadLink);
          // let url = downloadLink;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download",this.file_name_with_extenstion); //or any other extension
          document.body.appendChild(link);
          link.click();

    } else {
      console.log('Failed to retrieve the download link.');
    }
  } catch (e) {
    console.error('Error during download:', e);
  }
},
    async decrypt(payload){
    const key = process.env.VUE_APP_PAYSLIP_SECRET;
    const decipher = createDecipheriv('aes-256-cbc', key, Buffer.from(payload.iv, 'hex'));
    const decrypted = Buffer.concat([
        decipher.update(payload.encryptedPacket, 'base64'),
        decipher.final()
    ]);

    return decrypted.toString();
},



    createPreSignedUrl(){
      console.log('this.formData',this.formData['bill'])
      let splitedURl = this.preSignedUrl.split('.com/').pop()
      console.log("splitedUR",splitedURl)
      const filename =splitedURl.split('.');
      console.log("filename......",filename)
    // Split the filename by '.' to separate the extension
    const parts = filename[filename.length-1].split('-');
    console.log("parts",parts)
      const filenameWithExtension = this.employeeDocs[0].Employee.first_name+"."+parts[0];
      this.file_name_with_extenstion = filenameWithExtension
      console.log("filenameWithExtension",filenameWithExtension)
      const S3Config = {
      apiVersion: '2010-12-01',
      region: "ap-south-1",
      accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY,
      secretAccessKey: process.env.VUE_APP_AWS_SECRET_KEY,
    };
    const s3 = new S3(S3Config);
    return s3.getSignedUrlPromise('getObject', {
      Bucket: "paylief",
      Key:splitedURl,
      ResponseContentDisposition: `attachment; filename="${filenameWithExtension}"`
    });
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },

    saveValues(val, record, key) {
      this.componentKey+=1
      if(record.amount_approved <= record.amount_claimed){
      this.showError = false;
      record[key] = val;
      this.componentList = [];
      
      let componentDetails = {
        id: record.id,
        amount_approved: record.amount_approved
      }
      let isPresent = this.componentList.some(x => x.id === record.id);
      if(isPresent) {
        let index = this.componentList.findIndex(x => x.id === record.id);
        this.componentList[index][key] = record[key];
      } else {
        this.componentList.push(componentDetails);
      }
      //console.log(this.componentList,"line 478");
    }else{
      this.showError = true;
    }
    },
    saveRemark(val, record, key)
    {
      this.updatedRemark=record.remark
    },
    async performAction() {
        let data = {
        id:this.formData.id,
        amount_claimed:this.formData.amount_claimed,
        bill_amount: this.formData.bill_amount,
        bill_date: this.formData.bill_date,
        bill_number: this.bill_number,
        status: "approved",
        bill: this.formData.bill,
        amount_approved: this.componentList[0] ? Number(this.componentList[0].amount_approved):this.formData.amount_approved,
        remark: this.updatedRemark ? this.updatedRemark:this.formData.remark,
        for_month: this.formData.for_month,
        year: this.formData.year,
        fbp_component_id: this.formData.fbp_component_id,
        employee_id: this.formData.employee_id,
        legal_entity_id: this.formData.legal_entity_id,
        details:this.formData.details
      }
      
      try {
          let  res = await this.act_update(data);
          //console.log(res, ">>>>>>>>");
          if (res.data.status) {
            this.showSuccessMsg = true;
            this.$root._data.isSaving = false;
          }
        else {
          this.toast = true;
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

        async approveFbpClaim() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        } else {
          // PL_2427
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
    },

    back() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/approveFbpClaims`
      });
    },

    backfrompopup() {
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/approveFbpClaims`
      });
    },

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this. formate= new Intl.NumberFormat('en-in',{
        currency: "INR",
        style: "currency"
          });
       this.formateLess= new Intl.NumberFormat('en-in');
      //{org_id:this.orgId, le_id:this.le_id}
      this.role = data.data.user.userRole;
      this.companyValue = data.data.user.permissions.company ? true : false;
      //console.log("PL-3406",data);
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section



.main-header {
  color: #6d6d6d;
  margin-top: 37px;
  font-size: 16px;
}
.custom {
  width:180px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  border-color: #f5c2c7;
}
.margin-16{
  width: 100px !important;
}

.sm-img {
  width: 35%;
}


.document-counts {
  display: inline-block;
  font-weight: bold;
  margin: 0 8px 0 8px;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #34c0be;
}

.document-img {
  width: 24px;
  height: 18px;
  cursor: pointer;
}
.text-capitals{
  text-transform: capitalize;
  text-align: right;
}

</style>
